export default __webpack_public_path__ + "static/media/lipata_hazard_map.6b2f0d11.jpg";